import { ItemStateModel } from "./item-state.model"

export class ReviewDocumentState extends ItemStateModel {
    responsivenessStates: ResponsivenessState[];
    reviewedDocCount: number;

    get totalCaseDocCount(): number {
        return this.totalDocCount;
    }
}

export class ResponsivenessState {
    status: ReviewDocumentStatusType;
    statusCount: number;
}

export type ReviewDocumentStatusType = 'Responsive' | 'Non Responsive' | 'Not Specified' | 'Needs Further Review' | 'Reviewed' | 'Not Reviewed';
export type ReviewDocumentStatusCategory = 'Responsiveness' | 'Reviewed Status';